import {
  hasTempViewerSession,
  TEMP_VIEWER_NAME_KEY,
  TEMP_VIEWER_PASSWORD_KEY,
} from "../api/api";

export interface TempViewerIdentity {
  anonymousName: string;
  anonymousPassword: string;
}

const isValidAnonymousPassword = (value: string) => /^\d{4}$/.test(value);

export const getStoredTempViewerIdentity = (): TempViewerIdentity | null => {
  if (!hasTempViewerSession()) return null;

  const anonymousName = sessionStorage.getItem(TEMP_VIEWER_NAME_KEY);
  const anonymousPassword = sessionStorage.getItem(TEMP_VIEWER_PASSWORD_KEY);

  if (!anonymousName || !anonymousPassword) return null;

  return { anonymousName, anonymousPassword };
};

export const getStoredTempViewerName = () => {
  if (!hasTempViewerSession()) return null;
  return sessionStorage.getItem(TEMP_VIEWER_NAME_KEY);
};

export const setStoredTempViewerIdentity = (identity: TempViewerIdentity) => {
  sessionStorage.setItem(TEMP_VIEWER_NAME_KEY, identity.anonymousName);
  sessionStorage.setItem(TEMP_VIEWER_PASSWORD_KEY, identity.anonymousPassword);
};

export const ensureTempViewerIdentity = () => {
  if (!hasTempViewerSession()) return null;

  const stored = getStoredTempViewerIdentity();
  if (stored) return stored;

  const anonymousName = window.prompt("공유 링크 작성자 이름을 입력하세요.");
  if (!anonymousName?.trim()) return null;

  const anonymousPassword = window.prompt("4자리 숫자 비밀번호를 입력하세요.");
  if (!anonymousPassword?.trim()) return null;

  if (!isValidAnonymousPassword(anonymousPassword)) {
    window.alert("비밀번호는 숫자 4자리여야 합니다.");
    return null;
  }

  const identity = {
    anonymousName: anonymousName.trim(),
    anonymousPassword,
  };

  setStoredTempViewerIdentity(identity);
  return identity;
};

export const ensureTempViewerPassword = () => {
  if (!hasTempViewerSession()) return null;

  const storedPassword = sessionStorage.getItem(TEMP_VIEWER_PASSWORD_KEY);
  if (storedPassword && isValidAnonymousPassword(storedPassword)) {
    return storedPassword;
  }

  const password = window.prompt("작업을 계속하려면 4자리 숫자 비밀번호를 입력하세요.");
  if (!password?.trim()) return null;

  if (!isValidAnonymousPassword(password)) {
    window.alert("비밀번호는 숫자 4자리여야 합니다.");
    return null;
  }

  sessionStorage.setItem(TEMP_VIEWER_PASSWORD_KEY, password);
  return password;
};
